import { useState } from "react";

type Params<T> = {
  defaultValue: T;
  value?: T | undefined;
  onChange?: ((value: T) => void) | undefined;
};

function useControllableState<T>({ defaultValue, value, onChange }: Params<T>) {
  const [state_, setState_] = useState(defaultValue);

  const isControlled = value !== undefined;
  const state = isControlled ? value : state_;

  const handleChange: typeof onChange = (value) => {
    if (!isControlled) {
      setState_(value);
    }

    onChange?.(value);
  };

  return [state, handleChange] as const;
}

export { useControllableState };
